import { useContext } from "react";
import { Button } from "primereact/button";
import { VideoContext } from "../VideoContext";

const ActionPane = ({ hasExercise }: { hasExercise: boolean }) => {
  const {
    inLessonMode,
    inQuizMode,
    inExerciseMode,
    quiz,
    onQuizTake,
    onQuizReview,
    onLessonClick,
    onExerciseLaunch,
    isExercisePassed,
  } = useContext(VideoContext);

  const isQuizComplete = quiz.assessment?.answersCount === quiz.assessment?.questionsCount;

  return (
    <div className="flex flex-col gap-4 w-full">
      {(inQuizMode || inExerciseMode) && (
        <Button severity="secondary" label="Watch or read the lesson" onClick={onLessonClick} />
      )}
      {inLessonMode &&
        (isQuizComplete ? (
          <Button link label="Review quiz results" onClick={onQuizReview} />
        ) : (
          <Button label="Take the quiz" onClick={onQuizTake} />
        ))}
      {inLessonMode &&
        hasExercise &&
        (isExercisePassed ? (
          <Button link label="Launch the exercise" onClick={onExerciseLaunch} />
        ) : (
          <Button label="Pass the exercise" onClick={onExerciseLaunch} />
        ))}
    </div>
  );
};

export default ActionPane;
